import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useParams } from 'react-router-dom';
import listDatasetStorageLocations from 'api/Dataset/listDatasetStorageLocations';
import { SearchFilter } from 'types/Filters';
import { StorageLocation } from 'types/Dataset';
import { PaginationItems } from 'types/Pagination';

export default function useFolderList(filter: SearchFilter) {
    const client = useClient();
    const { openAlert } = useAlert();
    const params = useParams<{ uri: string }>();
    const [showSearchbar, setShowSearchbar] = useState(false);
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState<PaginationItems>({
        count: 0,
        pages: 0,
        page: 0,
    });
    const [error, setError] = useState(false);
    const [targetS3BucketName, setTargetS3BucketName] = useState('');
    const [folders, setFolders] = useState<StorageLocation[]>([]);

    const fetchData = async () => {
        try {
            setLoading(true);
            if (params.uri) {
                const response = await client.query(
                    listDatasetStorageLocations(params.uri, filter),
                );
                if (!response.errors) {
                    setItems(response.data.getDataset.locations);
                    setFolders(response.data.getDataset.locations.nodes);
                    setTargetS3BucketName(
                        response.data.getDataset.targetS3BucketName,
                    );
                    if (
                        response.data.getDataset.locations.count !== 0 &&
                        !showSearchbar
                    ) {
                        setShowSearchbar(true);
                    }
                } else {
                    setError(true);
                    openAlert({
                        message: `Something went wrong... Could not retrieve dataset details:${response.errors[0]?.message}`,
                        severity: 'alert',
                    });
                }
            }
        } catch (error) {
            setError(true);
            openAlert({
                message: 'An error occurred while fetching dataset details',
                severity: 'alert',
            });
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (client) {
            fetchData();
        }
    }, [client, params.uri, filter]);

    return {
        items,
        folders,
        error,
        loading,
        showSearchbar,
        targetS3BucketName,
        fetchData,
    };
}
